import loc, { format } from 'owa-localize';
import { GenericErrorText } from 'owa-locstrings/lib/strings/genericerrortext.locstring.json';
import { OneDriveFileProviderDisplayName } from 'owa-locstrings/lib/strings/onedrivefileproviderdisplayname.locstring.json';
import {
    AccessDeniedErrorText,
    EmptySearchResultDescriptionText,
    EmptySearchResultTitleText,
    GDriveFileProviderDisplayName,
    NoItemsText,
    NoProviderErrorText,
    NotFoundErrorText,
    SearchingText,
} from './FilePickerErrorMessageType.locstring.json';

const enum FilePickerErrorMessageType {
    Generic,
    NotFound,
    AccessDenied,
    NoItems,
    NoItemsSearch,
    Searching,
    NoOneDriveProvider,
    NoGDriveProvider,
}

export default FilePickerErrorMessageType;

export interface FilePickerErrorMessage {
    message: string;
    icon: string;
    messageSubtext?: string;
}

export const errorMessageMap: {
    [filePickerErrorMessageType: number]: () => FilePickerErrorMessage;
} = {
    [FilePickerErrorMessageType.Generic]: () =>
        <FilePickerErrorMessage>{
            message: loc(GenericErrorText),
            icon: 'o365-Icon--emptyError',
        },
    [FilePickerErrorMessageType.NotFound]: () =>
        <FilePickerErrorMessage>{
            message: loc(NotFoundErrorText),
            icon: 'o365-Icon--folderClosed',
        },
    [FilePickerErrorMessageType.AccessDenied]: () =>
        <FilePickerErrorMessage>{
            message: loc(AccessDeniedErrorText),
            icon: 'o365-Icon--lock3',
        },
    [FilePickerErrorMessageType.NoItems]: () =>
        <FilePickerErrorMessage>{ message: loc(NoItemsText), icon: 'o365-Icon--emptyFolder' },
    [FilePickerErrorMessageType.NoItemsSearch]: () =>
        <FilePickerErrorMessage>{
            message: loc(EmptySearchResultTitleText),
            icon: 'o365-Icon--emptyDocumentSearch',
            messageSubtext: loc(EmptySearchResultDescriptionText),
        },
    [FilePickerErrorMessageType.Searching]: () =>
        <FilePickerErrorMessage>{
            message: loc(SearchingText),
            icon: 'o365-Icon--magnifyingGlass',
        },

    [FilePickerErrorMessageType.NoOneDriveProvider]: () =>
        <FilePickerErrorMessage>{
            message: format(loc(NoProviderErrorText), loc(OneDriveFileProviderDisplayName)),
            icon: 'o365-Icon--folderClosed',
        },

    [FilePickerErrorMessageType.NoGDriveProvider]: () =>
        <FilePickerErrorMessage>{
            message: format(loc(NoProviderErrorText), loc(GDriveFileProviderDisplayName)),
            icon: 'o365-Icon--folderClosed',
        },
};
